export const STORAGE_KEY = {
  SHOW_TW_DISCLAIMER: "showTwDisclaimer"
}
